import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Dialog from '../Dialog/Dialog';
import styles from './SubscribeCancel.module.less';
import { handleCancelShow, cancelSubscribe } from '../../actions/layout';
import { getSubscribedAppList } from '../../actions/native';
import { createAxios } from '../../utils/utils';
import { SUBSCRIBE_REPOET_87 } from '../../config/index';
import Toast from '../Toast/Toast';
import { logging } from '../../actions/log';

const selectCancelShow = createSelector(
  state => state.layout,
  layout => layout.subscribeCancellationShow,
);

const seletUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const cancelShow = useSelector(selectCancelShow);
  const userInfo = useSelector(seletUserInfo);
  let cancelStyle = styles.cancel_g;
  let noCancelStyle = styles.no_cancel_g;
  if (cancelShow?.style === 'black' || cancelShow?.style === 'opacity') {
    cancelStyle = styles.cancel_b;
    noCancelStyle = styles.no_cancel_b;
  }

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Game_Appointment',
        label: '',
        param2: { softid: cancelShow.softId },
      }),
    );

    return () => {
      dispatch(handleCancelShow({ isShow: false, softId: null, style: null }));
    };
  }, []);

  const handleCancelDialog = info => {
    if (info === 1) {
      dispatch(
        logging({
          category: 'C',
          action: 'Game_Appointment_Close',
          label: '',
          param2: { softid: cancelShow.softId },
        }),
      );
    }

    if (info === 2) {
      dispatch(
        logging({
          category: 'C',
          action: 'Game_Appointment_N',
          label: '',
          param2: { softid: cancelShow.softId },
        }),
      );
    }

    dispatch(handleCancelShow({ isShow: false, softId: null, style: null }));
  };

  const handleSubscribeCancel = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Game_Appointment_Y',
        label: '',
        param2: { softid: cancelShow.softId },
      }),
    );
    createAxios().then(axios => {
      axios
        .get(SUBSCRIBE_REPOET_87, {
          params: {
            softId: cancelShow.softId,
            opType: 2,
          },
        })
        .then(res => {
          if (res?.data?.status === 0) {
            // dispatch(cancelSubscribe({ userId: userInfo?.uid, softId: cancelShow.softId }));
            dispatch(getSubscribedAppList());
            dispatch(handleCancelShow({ isShow: false, softId: null, style: null }));
            if (typeof window.CallForumUpdateSoftSubscribe === 'function') {
              window.CallForumUpdateSoftSubscribe();
            }
          } else {
            Toast.error({ content: '取消预约失败' });
          }
        })
        .catch(() => {
          Toast.error({ content: '取消预约失败' });
        });
    });
  };

  return (
    <Dialog
      title="温馨提示"
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={() => handleCancelDialog(1)}
    >
      <div className={styles.cancel_desc}>
        取消预约后，您将无法及时收到该游戏上架提醒，是否要取消？
      </div>
      <div className={styles.cancel_control}>
        <div className={cancelStyle} onClick={() => handleSubscribeCancel(2)}>
          仍要取消
        </div>
        <div className={noCancelStyle} onClick={() => handleCancelDialog(2)}>
          不，谢谢
        </div>
      </div>
    </Dialog>
  );
});
